import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import TipsAndTricks from '../TipsAndTricks/TipsAndTricks';
import styles from './LoadingInfo.module.scss';

const defaultTips = [
  {
    title: 'Move',
    description: 'Tap anywhere to walk.'
  },
  {
    title: 'Look Around',
    description: 'Drag to control the camera.'
  },
  {
    title: 'Profile',
    description: 'Tap your profile (top-right) to edit your name, icon, and description.'
  },
  {
    title: 'Express Yourself',
    description: 'Tap the wave icon (bottom-left) for emotes.'
  },
  {
    title: 'Avatar',
    description: 'Tap the shirt icon (bottom-left) to change your avatar.'
  },
  {
    title: 'Explore',
    description: 'Tap booths or yellow-framed images to interact.'
  }
];

type Props = {
  showTips?: boolean;
};

export default function LoadingText({ showTips = true }: Props) {
  if (!showTips) {
    return (
      <div className={styles.container}>
        <LoadingSpinner className={styles.info} />
        <p className={styles.info}>Loading...</p>
      </div>
    );
  }

  return (
    <TipsAndTricks
      tips={defaultTips}
      autoplayDelay={5000}
    />
  );
}
